module.exports = __webpack_public_path__ + "img/位图@2x(4).d573be54.png";